///////////////////////////////////////////////////////
// This file contains configs that affect layout     //
// NOTE: these are just some of the relevant configs //
// Most of the work happens in components.           //
///////////////////////////////////////////////////////

// Note: These come from the layout asset nowadays by default.
//       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeLayouts func)

// There are 2 SearchPage variants that can be used:
// 'map' & 'grid'
export const searchPage = {
  variantType: 'map',
};

// ListingPage has 2 layout options: 'coverPhoto' and 'carousel'.
// - 'coverPhoto' means a layout where there's a hero section with cropped image in the beginning of the page
// - 'carousel' shows image carousel, where listing images are shown with the original aspect ratio
export const listingPage = {
  variantType: 'carousel',
};

// ListingImage currently supports only one variant type, but it has aspectRatio as an extra configuration.
export const listingImage = {
  variantType: 'cropImage',
  // Aspect ratio for listing image variants (width/height)
  // Note: This will be converted to separate aspectWidth and aspectHeight values
  // to make calculations easier.
  aspectWidth: 4,
  aspectHeight: 2,
  aspectRatio: '4/2',
  // Listings have custom image variants, which are named here.
  variantPrefix: 'listing-card',
};

export const brandBanner = {
  variantType: 'cropImage',
  // Aspect ratio for listing image variants (width/height)
  // Note: This will be converted to separate aspectWidth and aspectHeight values
  // to make calculations easier.
  aspectWidth: 4,
  aspectHeight: 1,
  aspectRatio: '4/1',
  // Listings have custom image variants, which are named here.
  variantPrefix: 'brand-banner',
};

export const productImage = {
  variantType: 'cropImage',
  // Aspect ratio for listing image variants (width/height)
  // Note: This will be converted to separate aspectWidth and aspectHeight values
  // to make calculations easier.
  aspectWidth: 3,
  aspectHeight: 4,
  aspectRatio: '3/4',
  // Listings have custom image variants, which are named here.
  variantPrefix: 'product-card',
};

export const displayImage = {
  variantType: 'cropImage',
  // Aspect ratio for listing image variants (width/height)
  // Note: This will be converted to separate aspectWidth and aspectHeight values
  // to make calculations easier.
  aspectWidth: 1,
  aspectHeight: 1,
  aspectRatio: '1/1',
  // fit: 'scale',
  // Listings have custom image variants, which are named here.
  variantPrefix: 'display-card',
};

export const shopImage = {
  variantType: 'cropImage',
  aspectWidth: 4,
  aspectHeight: 3,
  aspectRatio: '4/3',
  fit: 'scale',
  // Listings have custom image variants, which are named here.
  variantPrefix: 'listing-card',
};
